// extracted by mini-css-extract-plugin
export default {"remove_button":"RemoveButton_remove_button__cD2NZ","remove_button_small":"RemoveButton_remove_button_small__cEQel","remove_button_large":"RemoveButton_remove_button_large__+PqSk"};